import React from "react";
import LoadingDots from "components/ui/LoadingDots";
import FormContentLayout from "components/layout/FormContentLayout";
import { FormSection } from "components/form";
import styled from "styled-components";

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 24px 0;
`;

const AccountSetupPendingMessage: React.FC = () => (
  <FormContentLayout
    heading="Please wait."
    subheading="Your account is being set up."
  >
    <FormSection>
      <LoadingWrapper>
        <LoadingDots />
      </LoadingWrapper>
    </FormSection>
  </FormContentLayout>
);

export default AccountSetupPendingMessage;
